





























import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';
import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { RecipientsHelper } from '@getaccept/lib-shared/src/recipients/helpers/recipients.helper';
import { DashboardWidgetHeaderColor } from '../../../types/enums/dashboard-widget-header-color';
import type { DashboardPerformer } from '../../../types/dashboard-performer';
import TopPerformerBar from './TopPerformerBar.vue';

export default defineComponent({
  name: 'TopPerformersWidgetItem',
  components: { TopPerformerBar },
  props: {
    performer: {
      type: Object as PropType<DashboardPerformer>,
      default: null,
    },
    topValue: {
      type: Number,
      default: 0,
    },
    currency: {
      type: Object as PropType<Currency>,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const hitrate = computed(
      () => `${Math.round((props.performer.count / props.performer.total) * 100)}%`
    );
    const description = computed(
      () => `${props.performer.count} ${t('closed-deals')} | ${hitrate.value} ${t('hit-rate')}`
    );

    return {
      fullName: RecipientsHelper.getRecipientFullName,
      description,
      DashboardWidgetHeaderColor,
      ParagraphSize,
      hitrate,
    };
  },
});
